import { apis } from "../constants";
import { request } from "../utils";

export const batchImportDevices = (projectId: number | string, data: FormData) => {
    return request(apis.batchImportDevices, { method: 'post', data, params: { projectId } })
}

export type SearchDevicesPayload = {
    queryDeviceSN: string,
    pageNum: number,
    pageSize: number,
    asc: boolean,
    sortField: string,
    online?: boolean | null,
}

export const searchDevices = (projectId: number | string, payload: Partial<SearchDevicesPayload>, isHistory = false) => {
    return request<PagedData<DeviceRecord>>(isHistory ? apis.searchHistoryProjectDevices : apis.searchDevice, { method: 'post', params: { projectId }, data: payload })
}

export const updateDevice = (projectId: string, deviceSn?: string, data?: DeviceRecord) => {
    return request(apis.updateDevice, {
        method: 'put', params: { projectId, deviceSn }, data
    })
}

export const deleteDevices = (projectId: string, deviceSns: any[]) => {
    return request(apis.batchDeleteDevices, {
        method: 'delete', params: { projectId }, data: deviceSns
    })
}

export const createDevices = (projectId: string, data: DeviceRecord[]) => {
    return request(apis.batchAddDevices, {
        method: 'post', params: { projectId }, data
    })
}

export const getDeviceDetails = (deviceSn: string) => {
    return request<DeviceRecord>(apis.getDeviceDetails, {
        method: 'get', params: { deviceSn }
    })
}

export const toggleSwitchesCommand = (data: any) => {
    return request(apis.toggleSwitches, {
        method: 'post', data
    })
}

export const globalDeviceSearch = (data: Partial<GlobalDeviceSearchParams>) => {
    return request<PagedData<GlobalDevice>>(apis.globalDeviceSearch, {
        method: 'post', data
    })
}

export const globalDeviceUpdate = (devSn: string, data: Partial<GlobalDevice>) => {
    return request(apis.globalDeviceUpdate, { method: 'put', params: { devSn }, data })
}

export const globalDeviceCreate = (data: Partial<GlobalDevice>) => {
    return request(apis.globalDeviceCreate, { method: 'post', data })
}

export const globalDeviceBatchDelete = (data: { devSnList: string[] }) => {
    return request(apis.globalDeviceBatchDelete, { method: 'post', data })
}

export const globalDeviceBatchImport = (data: FormData) => {
    return request(apis.globalDeviceBatchImport, { method: 'post', data })
}

export const deviceTransfer = (data: any) => {
    return request(apis.deviceTransfer, {method: 'post', data})
}

export const batchImportGlobalDevices = (data: FormData) => {
    return request(apis.batchImportGLobalDevices, { method: 'post', data })
}
